import gql from 'graphql-tag';

export const getAllDealCoinsMovements = gql`
  query getAllDealCoinsMovements($input: inputDealCoinsMovements) {
    getAllDealCoinsMovements(input: $input) {
      count_rows
      current_page
      can_back
      can_next
      total_page
      movements {
        id
        amount
        createdAt
        balance
        type
        comment
        fromUser {
          id
          username
          role
        }
        toUser {
          id
          username
          role
        }
        merchant {
          id
          username
        }
        consumer {
          id
          username
        }
        deal {
          id
          sku
          offer {
            title
          }
        }
      }
    }
  }
`;
